import React, { useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";

const MultiSelectDropdown = ({
  options = [],
  displayValue = "value",
  placeholder = "Select options",
  showCheckbox = true,
  handleChange,
  label,
  required,
  onBlur,
  errorMessage,
  isClearable = false,
  islabelfunction = false,
}) => {
  const [selectedValues, setSelectedValues] = useState([]);


  useEffect(() => {
    setSelectedValues([]);
  }, []);

  useEffect(() => {
    setSelectedValues([]);
    handleChange([]);
  }, [isClearable]);

  const handleSelectAllToggle = () => {
    if (selectedValues.length === options.length) {
      setSelectedValues([]);
      handleChange([]);
    } else {
      setSelectedValues(options);
      handleChange(options);
    }
  };

  const handleSelect = (selectedList) => {
    setSelectedValues(selectedList);
    handleChange(selectedList);
  };

  const handleRemove = (selectedList) => {
    setSelectedValues(selectedList);
    handleChange(selectedList);
  };

  return (
    <div
      tabIndex={0} // Keep div focusable
      onBlur={() => {
        if (onBlur) {
          setTimeout(() => {
            onBlur(selectedValues); // Ensure latest selected values are passed
          }, 0);
        }
      }}
    >
      <div className="d-flex gap-5 align-items-center mb-2">
        {label && (
          <label className="form-label font-size-14 form-label-custom-visible m-0">
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}
      </div>
      <div className="d-flex gap-5 align-items-center mb-2" >
        <label onClick={() => {
          if (islabelfunction) handleSelectAllToggle();
        }}
          htmlFor="selectAllCheckbox"
          className="text-black d-flex align-items-center cursor-pointer"
        >
          <input
            type="checkbox"
            id="selectAllCheckbox"
            checked={
              selectedValues.length === options.length && options.length > 0
            }
            onChange={handleSelectAllToggle}
            className="me-1"
          />
          Select / UnSelect All
        </label>
      </div>

      <Multiselect
        options={[...options].sort((a, b) =>
          a[displayValue].localeCompare(b[displayValue])
        )}
        selectedValues={selectedValues}
        onSelect={handleSelect}
        onRemove={handleRemove}
        displayValue={displayValue}
        placeholder={selectedValues?.length > 0 ? "" : placeholder}
        showCheckbox={showCheckbox}
        showArrow={true}
        className={
          errorMessage && Object?.keys(errorMessage).length > 0
            ? "multiSelectContainerError"
            : ""
        }
      />

      {errorMessage && Object?.keys(errorMessage).length > 0 && (
        <div className="text-danger fw-700 fs-6">
          {errorMessage &&
            errorMessage[displayValue] &&
            errorMessage[displayValue]}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
